import type { RequestOpts } from '@oazapfts/runtime';
import { Err, Ok } from 'ts-results-es';

import { appConfig } from '@/config';
import type { Auth } from '@/entities/auth';
import type { Me } from '@/entities/me';
import { UnreachableCaseError } from '@/utils/errors/unreachable-case-error';

import { FeApi } from '..';
import type { ISiteMetadataRepository } from '../domain/repositories/site-metadata.repository';
import type { RequestOptions } from '../domain/repositories/utils/request-options';
import { SiteMetadataRepositoryMapper } from '../mappers/site-metadata.repository.mapper';

export class FeApiSiteMetadataRepository implements ISiteMetadataRepository {
  constructor(
    private me: Me,
    private auth: Auth,
  ) {}

  private async getOpts(): Promise<RequestOpts> {
    const accessToken = await this.auth.getAccessToken();

    return {
      baseUrl: `${appConfig.bffUrl}/plex`,
      headers: {
        authorization: `Bearer ${accessToken}`,
        'x-user-email': this.me.email,
        'x-user-name': this.me.displayName,
      },
    };
  }

  async getAll(
    input: ISiteMetadataRepository.GetAllInput,
    requestOptions?: RequestOptions,
  ): Promise<ISiteMetadataRepository.GetAllOutput> {
    const opts = await this.getOpts();
    const body = SiteMetadataRepositoryMapper.getAll.bodyFromInput(input);
    const response = await FeApi.customerInfosV1SitesMetadataRetrieve(body, {
      ...opts,
      signal: requestOptions?.signal,
    });

    switch (response.status) {
      case 200: {
        const sections =
          await SiteMetadataRepositoryMapper.getAll.outputFromData(
            response.data,
          );

        return Ok({ sections });
      }
      case 404: {
        return Err({ type: 'NOT_FOUND' });
      }
      default: {
        throw new UnreachableCaseError(response);
      }
    }
  }
}
